const CHIP_TONES = {
  pending:   "lux-chip-warning",
  paid:      "lux-chip-success",
  overdue:   "lux-chip-danger",
  partial:   "lux-chip-warning",
  archived:  "lux-chip",
  confirmed: "lux-chip-accent",
  completed: "lux-chip-success",
  cancelled: "lux-chip-danger",
  no_show:   "lux-chip-danger",
  active:    "lux-chip-success",
  inactive:  "lux-chip",
};

const LABELS = {
  no_show: "No-show",
};

/**
 * Status chip — auto-tones based on the status keyword.
 * You can override via `tone="success|warning|danger|accent|neutral"`.
 */
export function NexaStatusChip({ status, tone, label, testId }) {
  const key = (status || "").toLowerCase();
  const toneClass =
    tone === "success" ? "lux-chip-success" :
    tone === "warning" ? "lux-chip-warning" :
    tone === "danger"  ? "lux-chip-danger" :
    tone === "accent"  ? "lux-chip-accent" :
    tone === "neutral" ? "" :
    CHIP_TONES[key] || "";

  const text = label ?? LABELS[key] ?? (status ? status[0].toUpperCase() + status.slice(1) : "");
  return (
    <span className={`lux-chip ${toneClass}`} data-testid={testId}>
      {text}
    </span>
  );
}
